import { DateTime } from 'luxon'
import React from 'react'
import { DATE_FORMAT_DISPLAY } from '../../../../constants'
import { BsFillPatchCheckFill } from "react-icons/bs";
import { ImCross } from "react-icons/im";


const ViewCandidateDetail = ({ row }) => {

  const CANDIDATE_DATE = [
    {
      name: "Apply For",
      value: row.job_title ? row.job_title : "Spontaneous Application",
    },
    {
      name: "First Name",
      value: row.first_name
    },
    {
      name: "Last Name",
      value: row.last_name,
    },
    {
      name: "Email",
      value: row.email,
    },
    {
      name: "Phone",
      value: row.phone?row.phone:"-",
    },
    {
      name: "Department",
      value: row.department?.title ? row.department?.title : "-",
    },
    {
      name: "Apply On",
      value: DateTime.fromISO(row.created_on).toFormat(DATE_FORMAT_DISPLAY),
    },
    {
      name: "Resume",
      value: <div>
        <a href={row.resume} target='_blank'>
          <button className='btn btn-small btn-primary cursor-pointer'>
            View  CV
          </button>
        </a>
      </div>,
    },
    {
      name: "Promotional Consent",
      // value: row.is_promotional_consent?<FaCircleCheck/>:"",
      value: row.is_promotional_consent?<BsFillPatchCheckFill className='text-green-600 text-2xl' />:<ImCross className='text-2xl text-red-600' />
    },
    {
      name: "Personal Consent",
      // value: row.is_personal_consent,
      value: row.is_personal_consent?<BsFillPatchCheckFill className='text-green-600 text-2xl' />:<ImCross className='text-2xl text-red-600' />,
    },
    {
      name: "Work Permit",
      // value: row.is_personal_consent,
      value: row.is_citizenship?<div className='flex space-x-2 mt-2'> <span className=''>Available</span> <BsFillPatchCheckFill className='text-green-600 text-2xl' /></div> :<div className='flex space-x-2 mt-2'> <span className=''>Not Available</span><ImCross className='text-xl text-red-600' /></div>,
    },






  ]

  return (
    <div className='grid grid-cols-3 gap-8'>
      {
        CANDIDATE_DATE.map((item) => (
          <div className='flex space-y-1 text-primary flex-col'>
            <div className='text-sm font-light'>{item.name}</div>
            <div className='font-medium'>{item.value}</div>
          </div>
        ))
      }
    </div>
  )
}

export default ViewCandidateDetail